import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { NoteSummary } from '~/models/modules/note';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({ providedIn: 'root' })
export class NotesService extends ApiServiceBase {
    constructor(injector: Injector, private http: HttpClient) {
        super(injector);
        this.setBase(API_NAMES.stocks);
    }

    // getAllNotes() {
    //     return this.http.get<NoteSummary[]>(this._url());
    // }

    getNotesByPage(fileId:number ,page: string) {
        return this.http.get<NoteSummary[]>(this._url(`/${fileId}/${page}`));
    }

    getNotesForUsersByPage(userEmail: string, page: string){

        return this.http.get<NoteSummary[]>(this._url(`/${userEmail}/${page}`))
    }

    createNote(model: any){
      return this.http.post(this._url(`/createNote`),model);
    }

    editNote(model: any){
      return this.http.put(this._url(`/editNote`),model);
    }


    private _url(v?: string | undefined) {
        v = v || '';
        return this.url(`/Notes${v}`);
    }
}
